import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	GetDenialLetterOdonto,
	DenialLetterOdontoParams,
	GetDenialLetterOdontoModel,
} from 'domain/usecases/private/authorizations-odonto/get-denial-letter-odonto';

export class RemoteGetDenialLetterOdonto implements GetDenialLetterOdonto {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<Blob>,
	) {}

	async get({signal, ...params}: DenialLetterOdontoParams): Promise<GetDenialLetterOdontoModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			responseType: 'blob',
			params,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return {denialLetter: httpResponse.data};
			case HttpStatusCode.created:
				return {denialLetter: httpResponse.data};
			case HttpStatusCode.noContent:
				return {denialLetter: httpResponse.data};
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
